import React from 'react';
import Page from '../../containers/page';
import RouteComponent from '../../helpers/route';
import ListBuilder from '../../list-builder';
import Isvg from 'react-inlinesvg';
import { Label, Input, Alert, Button } from 'reactstrap';
import editIcon from '../../assets/edit.svg';
import ApiKeys from '../../components/apiKeys';
import ExternalApiAnalytics from '../../components/externalApiAnalytics';
import ExternalApiLogs from '../../components/externalApiLogs';
import { toLogsFilters } from '../../helpers/externalApiLogs';
import { API_ENDPOINT } from '../../constants';
import {
    getExternalApiUsedBadge,
    getExternalApiAuthBadge,
    getExternalApiLastUsed,
    getExternalApiRequests7d,
    getExternalApiHeavyBadge,
    getExternalApiPoints7d,
    getExternalApiPeakLoadBadge,
} from '../../helpers/externalApiUsage';
import { formatNumber } from '../../helpers/format';

// VD-725: everything external-API related for customers (usage/cost columns,
// API keys, per-client analytics and logs) lives here, so the plain Customers
// page stays focused on account data. The list is always limited to clients
// that use the external API (see api.js).
class Screen extends RouteComponent {
    constructor(props) {
        super(props);
        this.state = {
            client: null,
            clientTab: 'apiKeys',
            apiLogsFilters: null,
            apiLogsFilterToken: 0,
            apiAnalyticsFilters: null,
            total: 20,
            items: [],
        }
    }

    componentDidMount() {
        this._onLoad();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props[0].location.search != prevProps[0].location.search) {
            this._onLoad();
        }

        // the analytics page's "Top clients" table links here by pre-filtering
        // on that client and asking to land straight on one of their tabs -
        // there is no "get client by id" route, so once the (already filtered)
        // list loads we just pick the matching row out of it.
        if (this.state.items !== prevState.items) {
            this._openFocusedClient();
        }
    }

    _openFocusedClient = () => {
        let params = this._getParams();

        if (!params.focusClientId) {
            return;
        }

        let match = this.state.items.find((item) => item._id === params.focusClientId);

        if (!match) {
            return;
        }

        // the global API analytics page passes its period along so the client's
        // tab opens on the same window
        let apiAnalyticsFilters = params.focusPreset ? {
            preset: params.focusPreset,
            customFrom: params.focusFrom || '',
            customTo: params.focusTo || '',
        } : null;

        this.setState({ client: match, clientTab: params.focusClientTab || 'apiKeys', apiAnalyticsFilters }, () => {
            this.updateMultipleParams([
                { name: 'focusClientId', value: null },
                { name: 'focusClientTab', value: null },
                { name: 'focusPreset', value: null },
                { name: 'focusFrom', value: null },
                { name: 'focusTo', value: null },
            ], false);
        });
    }

    _openAccountDetails = () => {
        let client = this.state.client;
        let filterValue = (client.customerData && client.customerData.id) || client.username || '';

        this.props[0].history.push(
            `/clients?filter=${encodeURIComponent(filterValue)}&focusClientId=${encodeURIComponent(client._id)}`
        );
    }

    export = () => {
        let params = this._getParams();

        let clients = {
            type: params.type ? params.type : 'all'
        };

        if (params.externalApiAuth === 'basic' || params.externalApiAuth === 'apiKey') {
            clients.externalApiAuth = params.externalApiAuth;
        } else {
            clients.useExternalApi = true;
        }

        if (params.externalApiHeavy === 'true' || params.externalApiHeavy === 'false') {
            clients.externalApiHeavy = params.externalApiHeavy === 'true';
        }

        if (params.sortField) {
            clients.sortField = params.sortField;
            clients.sortType = params.sortType ? params.sortType : -1;
        }

        fetch(API_ENDPOINT + '/data/clients/export?isVerified=clients', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify({
                clients: clients,
                type: true
            })
        }).then(res => res.blob()).then(data => { if (data) window.open(URL.createObjectURL(data)) })
    }

    // short two-line header for the 7-day metric columns: name on top, period underneath,
    // full description in the tooltip
    _metricLabel = (name, period, title) => {
        return <span className="th-stack" title={title.translate(this.props.lang)}>{name.translate(this.props.lang)}<small>{period.translate(this.props.lang)}</small></span>
    }

    render() {
        let params = this._getParams();
        let client = this.state.client;

        return (
            <div>
                <div className="section-title title-options">
                    <h1>{'Customers API usage'.translate(this.props.lang)}</h1>

                    <div className="ff-export">
                        <button onClick={this.export} className="button">Export </button>
                    </div>
                </div>
                {client ?
                    <div className="table-tabs">
                        <button onClick={() => this.setState({ client: null, clientTab: 'apiKeys', apiAnalyticsFilters: null })}>
                            {'Customers list'.translate(this.props.lang)}
                        </button>
                        <button className={this.state.clientTab == 'apiKeys' ? 'active' : ''} onClick={() => this.setState({ clientTab: 'apiKeys' })}>
                            {'API keys'.translate(this.props.lang)}
                        </button>
                        <button className={this.state.clientTab == 'apiAnalytics' ? 'active' : ''} onClick={() => this.setState({ clientTab: 'apiAnalytics' })}>
                            {'API analytics'.translate(this.props.lang)}
                        </button>
                        <button className={this.state.clientTab == 'apiLogs' ? 'active' : ''} onClick={() => this.setState({ clientTab: 'apiLogs' })}>
                            {'API logs'.translate(this.props.lang)}
                        </button>
                        <button onClick={this._openAccountDetails}>
                            {'Account details'.translate(this.props.lang)}
                        </button>
                    </div>
                    : null}

                {
                    client && this.state.clientTab == 'apiKeys' ?

                        <div className="side-margin">
                            <ApiKeys
                                lang={this.props.lang}
                                clientId={client._id}
                                apiAsync={this._apiAsync}
                            />
                        </div>

                        :

                    client && this.state.clientTab == 'apiAnalytics' ?

                        <div className="side-margin">
                            <ExternalApiAnalytics
                                lang={this.props.lang}
                                clientId={client._id}
                                externalApiSummary={client.externalApi}
                                initialFilters={this.state.apiAnalyticsFilters}
                                onOpenLogs={(logFilters) => this.setState((prev) => ({
                                    clientTab: 'apiLogs',
                                    apiLogsFilters: toLogsFilters(logFilters),
                                    apiLogsFilterToken: (prev.apiLogsFilterToken || 0) + 1,
                                }))}
                            />
                        </div>

                        :

                    client && this.state.clientTab == 'apiLogs' ?

                        <div className="side-margin">
                            <ExternalApiLogs
                                lang={this.props.lang}
                                clientId={client._id}
                                initialFilters={this.state.apiLogsFilters}
                                resetToken={this.state.apiLogsFilterToken}
                            />
                        </div>

                        :

                        <div className="clients-list api-usage-list">
                            {this.state.listError ?
                                <Alert color="danger" toggle={() => this.setState({ listError: null })}>
                                    {this.state.listError}
                                </Alert>
                                : null}

                            <ListBuilder
                                tabs={true}
                                sort={true}
                                tab1Name={'Customers list'.translate(this.props.lang)}
                                onClickTab1={() => {
                                    this.setState({ client: null, clientTab: 'apiKeys', apiAnalyticsFilters: null })
                                    this.updateMultipleParams([{ name: 'entries', value: "10" }, { name: 'page', value: 0 }, { name: 'filter', value: '' }], true);
                                }}
                                additionalFilterFields={<>
                                    <Label>
                                        {'Type'.translate(this.props.lang)} &nbsp;

                                        <Input style={{minWidth: 200}} type="select" className="entries"
                                               value={params.type ? params.type : 'all'}
                                               onChange={(e) => this.updateMultipleParams([{
                                                   name: 'type',
                                                   value: e.target.value
                                               }, {name: 'page', value: 0}], true)}>
                                            <option value={'all'}>All</option>
                                            <option value={'b2b'}>B2B</option>
                                            <option value={'briqpay'}>Briqpay</option>
                                            <option value={'partner'}>851 Partner</option>
                                            <option value={'friends'}>908 Friends</option>
                                            <option value={'sale'}>909 Sale</option>
                                            <option value={'refunder'}>1145 Refunder</option>
                                            <option value={'vind'}>1179 Vind</option>
                                            <option value={'verified'}>Verified</option>
                                            <option value={'non-verified'}>Non Verified</option>
                                        </Input>
                                    </Label>

                                    <Label>
                                        {'External API Auth'.translate(this.props.lang)} &nbsp;

                                        <Input style={{minWidth: 140}} type="select" className="entries"
                                               value={params.externalApiAuth ? params.externalApiAuth : ''}
                                               onChange={(e) => this.updateMultipleParams([{
                                                   name: 'externalApiAuth',
                                                   value: e.target.value
                                               }, {name: 'page', value: 0}], true)}>
                                            <option value={''}>All</option>
                                            <option value={'basic'}>Basic</option>
                                            <option value={'apiKey'}>API key</option>
                                        </Input>
                                    </Label>

                                    <Label title={'≥ 25% of capacity in a single minute (7 days)'.translate(this.props.lang)}>
                                        {'Heavy API user'.translate(this.props.lang)} &nbsp;

                                        <Input style={{minWidth: 140}} type="select" className="entries"
                                               value={params.externalApiHeavy ? params.externalApiHeavy : ''}
                                               onChange={(e) => this.updateMultipleParams([{
                                                   name: 'externalApiHeavy',
                                                   value: e.target.value
                                               }, {name: 'page', value: 0}], true)}>
                                            <option value={''}>All</option>
                                            <option value={'true'}>Yes</option>
                                            <option value={'false'}>No</option>
                                        </Input>
                                    </Label>

                                    <Button
                                        color="secondary"
                                        outline
                                        style={{ height: 42, marginLeft: 10, whiteSpace: 'nowrap' }}
                                        onClick={() => this.updateMultipleParams([
                                            { name: 'sortField', value: 'externalApi.peakLoad7d' },
                                            { name: 'sortType', value: -1 },
                                            { name: 'page', value: 0 },
                                        ], false)}
                                    >
                                        {'Heaviest API users'.translate(this.props.lang)}
                                    </Button>

                                </>}
                                lang={this.props.lang}
                                loading={this.state.loading}
                                total={this.state.total}
                                showNumeration={false}
                                fields={[
                                    { type: 'text', name: 'customerData.id', label: 'CUSTOMER NR.'.translate(this.props.lang), multilang: false, allowSort: true },
                                    { type: 'text', name: 'username', label: 'USERNAME'.translate(this.props.lang), multilang: false, allowSort: true, truncate: true, maxWidth: 160 },
                                    { type: 'text', name: 'email', label: 'EMAIL'.translate(this.props.lang), multilang: false, allowSort: true, truncate: true, maxWidth: 200 },
                                    { type: 'text', name: 'customerData.vatNumber', label: 'VAT'.translate(this.props.lang), multilang: false, allowSort: true, truncate: true, maxWidth: 140 },
                                    // cost (points/peak load) is the primary signal, requests stays as a
                                    // secondary column. "Use External API"/"Auth"/"Heavy"/"Overloaded min"
                                    // have no backend sort field; Points/Peak load/Requests/Last used do - their
                                    // `name` below is the literal sortField the backend expects, so the rendered
                                    // JSX is nested under `externalApi` in items.map() below rather than kept as
                                    // a separate top-level display key.
                                    { type: 'text', name: 'externalApiUsedDisplay', label: 'USE EXTERNAL API'.translate(this.props.lang), multilang: false },
                                    { type: 'text', name: 'externalApiAuthDisplay', label: 'EXTERNAL API AUTH'.translate(this.props.lang), multilang: false },
                                    // "Heavy user" has no column of its own any more - its badge sits in the peak load cell
                                    { type: 'text', name: 'externalApi.points7d', label: this._metricLabel('POINTS', '7D', 'Points (7 days)'), multilang: false, allowSort: true },
                                    { type: 'text', name: 'externalApi.peakLoad7d', label: this._metricLabel('PEAK LOAD', '7D', 'Peak load (7 days), heavy users are marked'), multilang: false, allowSort: true },
                                    { type: 'text', name: 'externalApiOverloadMinutesDisplay', label: this._metricLabel('OVERLOAD', 'MIN · 7D', 'Overloaded minutes (7 days)'), multilang: false },
                                    { type: 'text', name: 'externalApi.requests7d', label: this._metricLabel('REQUESTS', '7D', 'Requests (7 days)'), multilang: false, allowSort: true },
                                    { type: 'text', name: 'externalApi.lastUsedAt', label: 'LAST USED'.translate(this.props.lang), multilang: false, allowSort: true },

                                ]}
                                items={this.state.items.map((item) => {
                                    let usedBadge = getExternalApiUsedBadge(item.externalApi, this.props.lang);
                                    let authBadge = getExternalApiAuthBadge(item.externalApi, this.props.lang);
                                    let lastUsed = getExternalApiLastUsed(item.externalApi, this.props.lang);
                                    let requests7d = getExternalApiRequests7d(item.externalApi, this.props.lang);
                                    let heavyBadge = getExternalApiHeavyBadge(item.externalApi, this.props.lang);
                                    let points7d = getExternalApiPoints7d(item.externalApi, this.props.lang);
                                    let peakLoad = getExternalApiPeakLoadBadge(item.externalApi, this.props.lang);

                                    return {
                                        ...item,

                                        customerData: {
                                            ...item.customerData,
                                            id: <div style={{ display: 'flex', alignItems: 'center' }}><div className={`status ${item.verified ? 'active' : ''}`}></div> <span>{item.customerData ? item.customerData.id === 'link-909' ? 'Guest' : item.customerData.id : null}</span></div>
                                        },

                                        externalApiUsedDisplay: <span className={usedBadge.className}>{usedBadge.label}</span>,
                                        externalApiAuthDisplay: <span className={authBadge.className} title={authBadge.tooltip ? authBadge.tooltip : undefined}>{authBadge.label}</span>,
                                        externalApiOverloadMinutesDisplay: formatNumber(item.externalApi ? item.externalApi.overloadMinutes7d : 0),

                                        // Points (7d), Peak load (7d), Requests (7d) and Last used are sortable,
                                        // so their `name` above is the real backend sortField - the formatted JSX
                                        // has to replace the raw value at that same nested path.
                                        externalApi: {
                                            ...item.externalApi,
                                            points7d: <span title={points7d.tooltip}>{points7d.text}</span>,
                                            peakLoad7d: (
                                                <div className="load-cell">
                                                    <div className="load-cell-badges">
                                                        <span className={peakLoad.className}>{peakLoad.label}</span>
                                                        {heavyBadge ? <span className={heavyBadge.className}>{heavyBadge.label}</span> : null}
                                                    </div>
                                                    <div className="load-bar-track">
                                                        <div className="load-bar-fill" style={{ width: `${peakLoad.widthPercent}%`, backgroundColor: peakLoad.className.indexOf('expired') !== -1 ? '#d03b3b' : peakLoad.className.indexOf('grace') !== -1 ? '#a85400' : '#1b7a44' }} />
                                                    </div>
                                                </div>
                                            ),
                                            // requests is the secondary metric, muted so points/peak load lead the eye
                                            requests7d: <span style={{ color: '#818FA5', fontSize: 12 }} title={requests7d.tooltip}>{requests7d.text}</span>,
                                            lastUsedAt: <span title={lastUsed.tooltip ? lastUsed.tooltip : undefined}>{lastUsed.text}</span>,
                                        },
                                    }
                                })}
                                rawItems={this.state.items}
                                actions={
                                    [
                                        {
                                            component: <Isvg src={editIcon} />,
                                            onClick: (item) => this.setState({ client: item, clientTab: 'apiKeys', apiAnalyticsFilters: null })
                                        },
                                    ]
                                }

                                params={params}
                                sortField={params.sortField}
                                sortType={params.sortType}
                                updateSort={this.updateSort}
                                updateParams={this.updateParams}
                                updateMultipleParams={this.updateMultipleParams}
                            ></ListBuilder>
                        </div>
                }
            </div>
        )
    }
}

export default Page(Screen);
